import { differenceInCalendarDays } from 'date-fns'

import { Allocation } from '@percent/partner-dashboard/services/walletBalance/walletBalanceService.types'

const EXPIRY_WARNING_DAYS = 30

export type ExpiryBadge = { kind: 'none' } | { kind: 'warning'; daysLeft: number }

export function getExpiryBadge(allocation: Allocation, now: Date): ExpiryBadge {
  if (allocation.status !== 'active' || allocation.expiresAt === null) {
    return { kind: 'none' }
  }

  const daysLeft = differenceInCalendarDays(new Date(allocation.expiresAt), now)

  if (daysLeft >= 0 && daysLeft <= EXPIRY_WARNING_DAYS) {
    return { kind: 'warning', daysLeft }
  }

  return { kind: 'none' }
}
